module.exports = __webpack_public_path__ + "static/media/262b776e-94e5-437d-ae8c-b6bb0b317d16.a9877a71.jpg";